import React from 'react';
import './Impressum.css';

function AGBs() {
  return (
    <div className="impressum-page">
      <div className="impressum-container">
        <h1>Allgemeine Geschäftsbedingungen</h1>
        
        <section>
          <h2>1. Geltungsbereich</h2>
          <p>
            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung der Software "GarageDesk" 
            und alle damit verbundenen Dienstleistungen. Mit der Nutzung der Software akzeptieren Sie diese AGB.
          </p>
        </section>

        <section>
          <h2>2. Vertragsschluss</h2>
          <p>
            Der Vertrag kommt durch die Registrierung des Nutzers und die Annahme dieser AGB zustande. 
            Mit der Registrierung erklärt der Nutzer verbindlich, dass er diese AGB akzeptiert. 
            Wir behalten uns vor, die Registrierung ohne Angabe von Gründen abzulehnen.
          </p>
        </section>

        <section>
          <h2>3. Leistungsbeschreibung</h2>
          <p>
            GarageDesk ist eine Software zur Verwaltung von Werkstätten, Kunden, Fahrzeugen, Reparaturen 
            und Rechnungen. Die Software wird als Software-as-a-Service (SaaS) angeboten. Der Umfang der 
            Leistungen ergibt sich aus der jeweils gewählten Tarifvariante.
          </p>
          <p>
            Wir behalten uns vor, die Software weiterzuentwickeln und Funktionen zu ändern, zu erweitern 
            oder einzuschränken, soweit dies für den Nutzer zumutbar ist.
          </p>
        </section>

        <section>
          <h2>4. Preise und Zahlungsbedingungen</h2>
          <p>
            Die Preise für die Nutzung der Software ergeben sich aus der jeweils gültigen Preisliste. 
            Alle Preise verstehen sich in Euro zuzüglich der gesetzlichen Mehrwertsteuer.
          </p>
          <p>
            Die Zahlung erfolgt im Voraus für den jeweiligen Abrechnungszeitraum (monatlich oder jährlich). 
            Bei Zahlungsverzug nach Mahnung behalten wir uns vor, nach Setzung einer angemessenen Nachfrist 
            den Zugang zur Software einzuschränken oder den Vertrag zu kündigen. Vor einer Sperrung wird 
            der Nutzer rechtzeitig informiert und hat die Möglichkeit, seine Daten zu exportieren.
          </p>
          <p>
            <strong>Wichtig:</strong> Eine Sperrung erfolgt nur nach vorheriger Mahnung und nur, wenn der 
            Zahlungsverzug trotz Mahnung und Nachfrist fortbesteht. Der Nutzer hat vor einer Sperrung 
            stets die Möglichkeit, seine Daten zu exportieren.
          </p>
        </section>

        <section>
          <h2>5. Widerrufsrecht</h2>
          <p>
            <strong>Widerrufsrecht für Verbraucher:</strong>
          </p>
          <p>
            Wenn Sie Verbraucher sind (d.h. eine natürliche Person, die die Software zu einem Zweck 
            nutzt, der überwiegend weder ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit 
            zugerechnet werden kann), steht Ihnen ein Widerrufsrecht zu.
          </p>
          <p>
            Sie können Ihre Vertragserklärung innerhalb von 14 Tagen ohne Angabe von Gründen widerrufen. 
            Die Frist beginnt nach Abschluss des Vertrags. Zur Wahrung der Widerrufsfrist genügt die 
            rechtzeitige Absendung des Widerrufs.
          </p>
          <p>
            Der Widerruf ist zu richten an: Thomas Ringler, Am Pfalzbach 52B, 91413 Neustadt/Aisch, 
            E-Mail: mail@thomas-ringler.de
          </p>
        </section>

        <section>
          <h2>6. Nutzungsrechte</h2>
          <p>
            Der Nutzer erhält ein nicht-exklusives, nicht-übertragbares Recht zur Nutzung der Software 
            für die Dauer des Vertragsverhältnisses. Eine Weitergabe, Vermietung oder Verpachtung der 
            Software ist nicht gestattet.
          </p>
          <p>
            Alle Rechte an der Software, einschließlich des Urheberrechts, bleiben beim Anbieter. 
            Der Nutzer ist nicht berechtigt, die Software zu kopieren, zu modifizieren oder zu dekompilieren.
          </p>
        </section>

        <section>
          <h2>7. Verfügbarkeit und Störungen</h2>
          <p>
            Wir bemühen uns um eine hohe Verfügbarkeit der Software. Eine Verfügbarkeit von 99% wird angestrebt, 
            kann jedoch nicht garantiert werden. Wartungsarbeiten werden nach Möglichkeit außerhalb der 
            Geschäftszeiten durchgeführt und werden dem Nutzer rechtzeitig angekündigt.
          </p>
          <p>
            Bei Störungen werden wir diese innerhalb angemessener Frist beheben. Der Nutzer ist verpflichtet, 
            Störungen unverzüglich zu melden.
          </p>
        </section>

        <section>
          <h2>8. Support und Service</h2>
          <p>
            Der Umfang des Supports ergibt sich aus der gewählten Tarifvariante. Support-Anfragen können 
            über die in der Software bereitgestellten Kontaktmöglichkeiten gestellt werden.
          </p>
        </section>

        <section>
          <h2>9. Datensicherheit und Datenschutz</h2>
          <p>
            Wir setzen moderne Sicherheitstechnologien ein, um Ihre Daten zu schützen. Regelmäßige Backups 
            werden durchgeführt. Dennoch kann keine absolute Sicherheit garantiert werden. Der Nutzer ist 
            verpflichtet, seine Zugangsdaten geheim zu halten.
          </p>
          <p>
            Nähere Informationen zum Datenschutz finden Sie in unserer 
            <a href="/datenschutz">Datenschutzerklärung</a>.
          </p>
        </section>

        <section>
          <h2>10. Nutzerpflichten</h2>
          <p>
            Der Nutzer verpflichtet sich:
          </p>
          <ul>
            <li>die Software nur im Rahmen der gesetzlichen Bestimmungen zu nutzen</li>
            <li>keine rechtswidrigen Inhalte einzustellen oder zu verbreiten</li>
            <li>die Zugangsdaten geheim zu halten und Dritten keinen Zugang zu gewähren</li>
            <li>bei Bekanntwerden von Sicherheitslücken diese unverzüglich zu melden</li>
            <li>keine Maßnahmen zu ergreifen, die die Funktionsfähigkeit der Software beeinträchtigen</li>
          </ul>
        </section>

        <section>
          <h2>11. Vertraulichkeit</h2>
          <p>
            Beide Vertragsparteien verpflichten sich, alle ihnen im Rahmen des Vertragsverhältnisses 
            bekannt gewordenen Geschäfts- und Betriebsgeheimnisse vertraulich zu behandeln und nicht 
            an Dritte weiterzugeben.
          </p>
        </section>

        <section>
          <h2>12. Haftung</h2>
          <p>
            Wir haften unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie nach Maßgabe des 
            Produkthaftungsgesetzes.
          </p>
          <p>
            Bei leichter Fahrlässigkeit haften wir nur bei Verletzung einer wesentlichen Vertragspflicht, 
            deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf 
            deren Einhaltung der Nutzer regelmäßig vertrauen darf (Kardinalpflicht). In diesem Fall ist 
            die Haftung auf die bei Vertragsschluss vorhersehbaren, vertragstypischen Schäden begrenzt.
          </p>
          <p>
            Die Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit es sich nicht um die Verletzung 
            einer Kardinalpflicht handelt. Die vorstehenden Haftungsbeschränkungen gelten nicht bei 
            Verletzung von Leben, Körper oder Gesundheit.
          </p>
        </section>

        <section>
          <h2>13. Kündigung</h2>
          <p>
            Das Vertragsverhältnis kann von beiden Seiten mit einer Frist von 30 Tagen zum Monatsende gekündigt 
            werden. Bei schwerwiegenden Verstößen gegen diese AGB (z.B. missbräuchliche Nutzung, Weitergabe 
            von Zugangsdaten an Dritte, Verstoß gegen gesetzliche Bestimmungen) behalten wir uns eine fristlose 
            Kündigung vor.
          </p>
          <p>
            Nach Beendigung des Vertragsverhältnisses werden die Daten des Nutzers gelöscht, sofern keine 
            gesetzlichen Aufbewahrungspflichten bestehen. Der Nutzer ist verantwortlich, seine Daten vor 
            Vertragsende zu exportieren. Wir gewähren nach Vertragsende eine angemessene Frist für den 
            Datenexport.
          </p>
          <p>
            <strong>Hinweis zur Zugangssperre:</strong> Eine Sperrung des Zugangs erfolgt nur in Ausnahmefällen 
            (z.B. bei Sicherheitsrisiken oder schwerwiegenden Vertragsverstößen) und nur nach vorheriger 
            Ankündigung. Bei Zahlungsverzug erfolgt eine Sperrung nur nach Mahnung und Nachfrist. Der Nutzer 
            hat vor einer Sperrung stets die Möglichkeit, seine Daten zu exportieren.
          </p>
        </section>

        <section>
          <h2>14. Änderungen der AGB</h2>
          <p>
            Wir behalten uns vor, diese AGB zu ändern. Änderungen werden dem Nutzer mindestens 30 Tage vor 
            Inkrafttreten mitgeteilt. Widerspricht der Nutzer nicht innerhalb von 30 Tagen nach Zugang der 
            Mitteilung, gelten die Änderungen als genehmigt. Auf die Rechtsfolgen des Schweigens wird der 
            Nutzer in der Mitteilung besonders hingewiesen.
          </p>
        </section>

        <section>
          <h2>15. Schlussbestimmungen</h2>
          <p>
            Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Gerichtsstand ist, soweit gesetzlich 
            zulässig, der Sitz des Anbieters. Handelt es sich beim Nutzer um einen Kaufmann, eine juristische 
            Person des öffentlichen Rechts oder ein öffentlich-rechtliches Sondervermögen, so ist ausschließlicher 
            Gerichtsstand der Sitz des Anbieters.
          </p>
          <p>
            Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der 
            übrigen Bestimmungen unberührt. An die Stelle der unwirksamen Bestimmung tritt die gesetzlich 
            zulässige Bestimmung, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
          </p>
        </section>
      </div>
    </div>
  );
}

export default AGBs;

